module.exports = "<div class=\"youtube-player\">\n  <iframe\n    [src]=\"urlSafe\"\n    title=\"YouTube video player\"\n    frameborder=\"0\"\n    allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\"\n    allowfullscreen\n  ></iframe>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/youtube-player/youtube-player.template.html
// module id = 852
// module chunks = 2